import React, { Component } from 'react'
import '../styles/OrgRegistration.css'
import finance from '../images/finance.png'
import financing from '../images/financing.png'
import aec from '../images/AEC.png'
import orgProfile from '../images/organizational-profile.png'
import smallInfra from '../images/small-infra.png'
import OrganizationalProfile from './OrganizationalProfile'
// import OrganizationMembership from './OrganizationMembership'
import OrganizationCapitalization from './OrganizationCapitalization'
import OrganizationFinancingTrack from './OrganizationFinancingTrack'
import OrganizationInfraProvided from './OrganizationInfraProvided'
import OrganizationInfraUsage from './OrganizationInfraUsage'
import OrganizationAECommittee from './OrganizationAECommittee'
import PopupMenu from '../widgets/PopupMenu'

class OrgRegistration extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accountType: props.type,
			arboId: props.id,
			isDisabled: (props.id != null)? false: true,
			isViewDetails: props.isViewDetails
		}
		this.onMenuItemClick = this.onMenuItemClick.bind(this)
		this.onSignal = this.onSignal.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
		this.setContent = this.setContent.bind(this)
	}

	componentDidMount() {
		this.setContent(sessionStorage.getItem("org-tabId"))
	}

	onSubmit() {
		this.setState({isDisabled: false})
	}

	onSignal(from, obj) {
		this.props.onSignal(from, obj)
	}

	onMenuItemClick(v) {
		this.setState({activeItem: v})
	}

	setContent(id) {
		let content
		switch(id) {
			// case "orh-membership":
			// 	content = <OrganizationMembership isViewDetails={this.state.isViewDetails} />
			// 	break
			case "orh-capitalization":
				content = <OrganizationCapitalization displayValues={!this.state.isDisabled} isViewDetails={this.state.isViewDetails} />
				break
			case "orh-track":
				content = <OrganizationFinancingTrack displayValues={!this.state.isDisabled} isViewDetails={this.state.isViewDetails} />
				break
			case "orh-infraprovided":
				content = <OrganizationInfraProvided displayValues={!this.state.isDisabled} isViewDetails={this.state.isViewDetails} />
				break
			case "orh-infrausage":
				content = <OrganizationInfraUsage displayValues={!this.state.isDisabled} isViewDetails={this.state.isViewDetails} />
				break
			case "orh-committee":
				content =  <OrganizationAECommittee displayValues={!this.state.isDisabled} isViewDetails={this.state.isViewDetails} />
				break
			default:
				content = <OrganizationalProfile isViewDetails={this.state.isViewDetails}
					displayValues={!this.state.isDisabled} submit={this.onSubmit} />
		}
		this.setState({content: content})
	}

	render() {
		const view = <div id="org-registration">
			<Header onItemClick={(item) => {
				this.setContent(item)
				sessionStorage.setItem("org-tabId", item)
			}} isDisabled={this.state.isDisabled} />
			<Body content={this.state.content} />
		</div>
		return(view)
	}
}

class Header extends Component
{
	constructor(props) {
		super(props)
		this.state = {isDisabled: props.isDisabled}
		this.onItemClick = this.onItemClick.bind(this)
		this.mouseEnter = this.mouseEnter.bind(this)
		this.mouseLeave = this.mouseLeave.bind(this)
		this.setBurgerMenuLabel = this.setBurgerMenuLabel.bind(this)
	}

	componentDidMount() {
		if(this.state.isDisabled) {
			this.setBurgerMenuLabel("orh-profile")
			return
		}
		const items = document.querySelectorAll('#list-menu-org > div')
		for(const f of items) {
			f.style.color = "#000"
		}
		const imgs = document.querySelectorAll('#list-menu-org > div > img')
		for(const f of imgs) {
			f.style.opacity = "1.0"
		}
		const tabId = sessionStorage.getItem("org-tabId")
		switch(tabId) {
			// case "orh-membership":
			case "orh-capitalization":
			case "orh-track":
			case "orh-infraprovided":
			case "orh-infrausage":
			case "orh-committee":
			// case "orh-membership-bm":
			case "orh-capitalization-bm":
			case "orh-track-bm":
			case "orh-infraprovided-bm":
			case "orh-infrausage-bm":
			case "orh-committee-bm":
				var elem = document.getElementById(tabId)
				elem.style.background = "#e2e2e2"
				break
			default:
				elem = document.getElementById("orh-profile")
				elem.style.background = "#e2e2e2"
		}
		this.setBurgerMenuLabel(tabId)
	}

	componentDidUpdate(prevProps) {
		if(this.props.isDisabled != prevProps.isDisabled) {
			this.setState({isDisabled: this.props.isDisabled})
			if(this.props.isDisabled) {
				return
			}
			const items = document.querySelectorAll('#list-menu-org > div')
			for(const f of items) {
				f.style.color = "#000"
			}
			const imgs = document.querySelectorAll('#list-menu-org > div > img')
			for(const f of imgs) {
				f.style.opacity = "1.0"
			}
		}
	}

	onItemClick(e) {
		if(this.state.isDisabled) {
			return
		}
		const items = document.querySelectorAll('#list-menu-org > div')
		for(const f of items) {
			f.style.background = "#ffffff"
		}
		e.target.style.background = "#e2e2e2"
		this.props.onItemClick(e.target.id)
		this.setBurgerMenuLabel(e.target.id)
	}

	mouseEnter(e) {
		if(this.state.isDisabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#e2e2e280"
	}

	mouseLeave(e) {
		if(this.state.isDisabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#ffffff"
	}

	setBurgerMenuLabel(id) {
		switch(id) {
			case "orh-capitalization":
			case "orh-capitalization-bm":
				var bmLabel = <div><img src={finance} />CAPITALIZATION</div>
				break
			case "orh-track":
			case "orh-track-bm":
				bmLabel = <div><img src={financing} />FINANCING TRACKING</div>
				break
			case "orh-infraprovided":
			case "orh-infraprovided-bm":
				bmLabel = <div><img src={smallInfra} />SMALL INFRA SUP. PROVIDED</div>
				break
			case "orh-infrausage":
			case "orh-infrausage-bm":
				bmLabel = <div><img src={smallInfra} />SMALL INFRA SUP. USAGE</div>
				break
			case "orh-committee":
			case "orh-committee-bm":
				bmLabel = <div><img src={aec} />AGRO ENTERPRISE COMMITTEE</div>
				break
			default:
				var bmLabel = <div><img src={orgProfile} />ORGANIZATION PROFILE</div>
		}
		this.setState({bmLabel: bmLabel})
	}



	render() {
		const view = <div id="org-reg-header">
			<div id="burger-menu-org">
				<PopupMenu list={ [
					{id: "orh-profile-bm", name: "ORGANIZATION PROFILE"},
					{id: "orh-capitalization-bm", name: "CAPITALIZATION"},
					{id: "orh-track-bm", name: "FINANCING TRACKING"},
					{id: "orh-infraprovided-bm", name: "SMALL INFRA SUP. PROVIDED"},
					{id: "orh-infrausage-bm", name: "SMALL INFRA SUP. USAGE"},
					{id: "orh-committee-bm", name: "AGRO ENTERPRISE COMMITTEE"}
				]} onItemSelected={(id, val) => {
					if(this.state.isDisabled) {
						return
					}
					this.setBurgerMenuLabel(id)
					const idStr = id.split('-')
					this.props.onItemClick(idStr[0] + "-" + idStr[1])
					const items = document.querySelectorAll('#list-menu-org > div')
					for(const f of items) {
						f.style.background = "#ffffff"
					}
					const elem = document.getElementById(idStr[0] + "-" + idStr[1])
					elem.style.background = "#e2e2e2"
				}}/>
				<div id="burger-menu-org-label">{this.state.bmLabel}</div>
			</div>
			<div id="list-menu-org">
				<div id="orh-profile" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
					onMouseLeave={this.mouseLeave}><img src={orgProfile} />ORGANIZATION PROFILE</div>
				<div id="orh-capitalization" onClick={this.onItemClick}
					onMouseEnter={this.mouseEnter}
					onMouseLeave={this.mouseLeave}><img src={finance} />CAPITALIZATION</div>
				<div id="orh-track" onClick={this.onItemClick}
					onMouseEnter={this.mouseEnter}
					onMouseLeave={this.mouseLeave}><img src={financing} />FINANCING TRACKING</div>
				<div id="orh-infraprovided" onClick={this.onItemClick}
					onMouseEnter={this.mouseEnter}
					onMouseLeave={this.mouseLeave}><img src={smallInfra} />SMALL INFRA SUP. PROVIDED</div>
				<div id="orh-infrausage" onClick={this.onItemClick}
					onMouseEnter={this.mouseEnter}
					onMouseLeave={this.mouseLeave}><img src={smallInfra} />SMALL INFRA SUP. USAGE</div>
				<div id="orh-committee" onClick={this.onItemClick}
					onMouseEnter={this.mouseEnter}
					onMouseLeave={this.mouseLeave}><img src={aec} />AGRO ENTERPRISE COMMITTEE</div>
			</div>
		</div>
		return(view)
	}
}

class Body extends Component
{
	constructor(props) {
		super(props)
		this.onItemClick = this.onItemClick.bind(this)
	}

	onItemClick(e) {
		console.log(e.target.id)
	}

	render() {
		const view = <div id="org-reg-body">
			<div id="orb-content">
				{this.props.content}
			</div>
		</div>
		return(view)
	}
}

export default OrgRegistration
